import {productsStep, ProductsStep} from "./products/TfStoreProductsStep";

import {ConfirmStep, confirmStep} from "./confirm/TfStoreConfirmStep";

export default function(parentDir: string) {

    const rootDir =  `${parentDir}/components`;

    return angular.module("tfApp.store.tf.components", [])
                  .component(ProductsStep, productsStep(rootDir))
                  .component(ConfirmStep, confirmStep(rootDir))
                  .name;
}
